var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"mode":"out-in","enter-active-class":"fadeIn","leave-active-class":"fadeOut"}},[_c('router-view',{staticClass:"animated"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }